"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// << player-is-implements-import
const video_client_core_1 = require("@video/video-client-core");
// << end-player-is-implements-import
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../context");
const styling_1 = require("../../../styling");
const useRefDimensions_1 = require("../../../ui-lib/Hooks/useRefDimensions");
const VideoWrapper_1 = tslib_1.__importDefault(require("../../../ui-lib/VideoWrapper"));
const styles_1 = require("../../../ui-lib/VideoWrapper/styles");
const ErrorBoundary_1 = require("../../ErrorBoundary");
const Video_1 = require("./Video");
const ModularVideo = (0, mobx_react_lite_1.observer)(({ classes, adaptiveBlur, adaptiveBlurValues, elementBlur, blurPixels, ...props }) => {
    var _a;
    const componentName = "<PlayerVideo/>";
    /**
     * @todo: Not sure how we want to handle styles for this.
     */
    const ctx = (0, react_1.useContext)(context_1.PlayerUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.videoElement) != null, componentName);
    // << player-is-implements
    const blurredVideo = adaptiveBlur || elementBlur || (ctx.player.isImplements(video_client_core_1.player.Feature.BITRATE_SWITCHING) && ctx.player.blurred);
    // << end-player-is-implements
    const { width } = (0, useRefDimensions_1.useRefDimensions)(ctx === null || ctx === void 0 ? void 0 : ctx.videoElement);
    // A video element width of 360 will use 9 blur pixels
    // A video element width of 1920 will use 15 blur pixels
    // Other width blur values will be calculated based on a linear regression of the above
    const adaptiveBlurPixels = (elWidth) => {
        var _a, _b;
        const minWidth = 360;
        const maxWidth = 1920;
        const minBlurPixels = (_a = adaptiveBlurValues === null || adaptiveBlurValues === void 0 ? void 0 : adaptiveBlurValues.min) !== null && _a !== void 0 ? _a : 9;
        const maxBlurPixels = (_b = adaptiveBlurValues === null || adaptiveBlurValues === void 0 ? void 0 : adaptiveBlurValues.max) !== null && _b !== void 0 ? _b : 15;
        return ((maxBlurPixels - minBlurPixels) * (elWidth - minWidth)) / (maxWidth - minWidth) + minBlurPixels;
    };
    blurPixels = adaptiveBlur ? adaptiveBlurPixels(width) : blurPixels;
    const styling = (0, styles_1.videoWrapperStyles)({
        pillarBox: (_a = props.pillarBox) !== null && _a !== void 0 ? _a : false,
        fullScreen: props.isFullScreen,
        mirror: props.mirror,
        elementBlur: blurredVideo,
        blurPixels,
    });
    const mergedClasses = (0, styling_1.useStyles)({ source: classes !== null && classes !== void 0 ? classes : {}, target: styling }, "videoWrapper");
    // @TODO Needs to be added back in when this feature is fixed
    /*
  useEffect(
    () =>
      autorun(() => {
        const p = ctx?.player;
        const el = ctx?.videoElement;
        if (p == null || !(el instanceof HTMLVideoElement)) {
          return;
        }

        if (p.isImplements(player.Feature.CONSUMER)) {
          const logCtx = {
            streamName: p.streamName,
            consumerVideoEnabled: p.consumerVideoEnabled,
          };

          if (p.consumerVideoEnabled) {
            ctx?.logger?.debug("Video element is visible", logCtx);
            el.style.visibility = "";
          } else {

            //ctx?.logger?.debug("Video element is hidden", logCtx);
            //el.style.visibility = "hidden";
          }

        } else {
          el.style.visibility = "";
        }

      }),
    [ctx?.logger, ctx?.player, ctx?.videoElement, ctx?.player.format],
  );
  */
    return (react_1.default.createElement(VideoWrapper_1.default, { isFullScreen: ctx === null || ctx === void 0 ? void 0 : ctx.isFullscreen, classes: classes, ref: ctx.videoWrapperElement, elementBlur: blurredVideo, blurPixels: blurPixels, ...props },
        react_1.default.createElement(Video_1.Video, { source: ctx.player, autoPlay: false, className: mergedClasses.videoElement, ref: ctx.videoElement, id: props.id })));
});
const PlayerVideoWithErrorBoundary = ({ classes, ...props }) => {
    return (
    /**
     * @todo: Temporary fallback. Update for a real fallback.
     */
    react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement("div", { style: { height: "600px", width: "100%" } },
            react_1.default.createElement("p", null, "Video is not working"))) },
        react_1.default.createElement(ModularVideo, { classes: classes, ...props })));
};
exports.default = PlayerVideoWithErrorBoundary;
//# sourceMappingURL=PlayerVideo.js.map